import { createAsyncActionType } from './index';

export const SIGNIN = createAsyncActionType('authentication', 'SIGNIN');
export const FORGOT_PASSWORD = createAsyncActionType(
  'authentication',
  'FORGOT_PASSWORD'
);
export const FORGOT_PASSWORD_SUBMIT = createAsyncActionType(
  'authentication',
  'FORGOT_PASSWORD_SUBMIT'
);

export const GET_CURRENT_USER = createAsyncActionType(
  'authentication',
  'GET_CURRENT_USER'
);
export const SIGNOUT = createAsyncActionType('authentication', 'SIGNOUT');

export const GET_CURRENT_USER_ACCOUNT_INFO = createAsyncActionType(
  'authentication',
  'GET_CURRENT_USER_ACCOUNT_INFO'
);

export const COMPLETE_NEW_PASSWORD_SUBMIT = createAsyncActionType(
  'authentication',
  'COMPLETE_NEW_PASSWORD_SUBMIT'
);

export const UPDATE_USER_PROFILE_DATA = createAsyncActionType(
  'authentication',
  'UPDATE_USER_PROFILE_DATA'
);

export const FORGOT_PASSWORD_RESEND_OTP = createAsyncActionType(
  'authentication',
  'FORGOT_PASSWORD_RESEND_OTP'
);
